export default __webpack_public_path__ + "static/media/avatar_104.ed09a280.png";